import React, { useState } from 'react';
import {Container} from '../../../globalStyles';
import {
DataDeletionSec,
DataDeletionSection,
Heading,
Subtitle,
Subtitleh3,
Text,
Lista,
ListaItem,
FormSection,
FormLabel,
FormInput,
FormTextarea,
SubmitButton,
AlertBox,
ContactBox,
EmailLink
} from './DataDeletionRequest.elements';


const DataDeletionRequest = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    facebookId: '',
    reason: '',
    additionalInfo: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí se implementaría la lógica para enviar la solicitud
    console.log('Solicitud de eliminación de datos:', formData);
    setSubmitted(true);
  };

  return (
    <>
      <DataDeletionSec>
        <Container>

          <DataDeletionSection>
            <Heading>Solicitud de Eliminación de Datos - Facebook Login</Heading>
            <Subtitle><i>Última actualización: 16 de diciembre de 2025</i></Subtitle>

            <Text>
              En cumplimiento con las políticas de Facebook para aplicaciones que utilizan Facebook Login,
              KUSINA APP E.I.R.L. proporciona esta página para que los usuarios puedan solicitar la eliminación
              de sus datos personales recopilados a través de la integración con Facebook.
            </Text>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>1. ¿Qué Datos se Recopilan de Facebook?</Heading>
            <Text>
              Cuando inicias sesión en Kusina utilizando tu cuenta de Facebook, podemos recopilar la siguiente información:
            </Text>
            <Lista>
              <ListaItem><Text><strong>Información básica de perfil:</strong> Nombre, apellido, foto de perfil.</Text></ListaItem>
              <ListaItem><Text><strong>Correo electrónico:</strong> Tu dirección de correo electrónico asociada a tu cuenta de Facebook.</Text></ListaItem>
              <ListaItem><Text><strong>ID de usuario de Facebook:</strong> Identificador único proporcionado por Facebook.</Text></ListaItem>
            </Lista>
            <Text>
              Esta información se utiliza exclusivamente para facilitar el proceso de registro e inicio de sesión
              en nuestra plataforma, así como para personalizar tu experiencia como usuario.
            </Text>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>2. Tu Derecho a la Eliminación de Datos</Heading>
            <Text>
              De acuerdo con la <strong>Ley N° 29733 - Ley de Protección de Datos Personales de Perú</strong> y
              las políticas de Facebook, tienes derecho a solicitar la eliminación de tus datos personales
              en cualquier momento.
            </Text>

            <Subtitle>2.1. ¿Qué Datos se Eliminarán?</Subtitle>
            <Text>Al solicitar la eliminación de datos, se eliminarán:</Text>
            <Lista>
              <ListaItem><Text>Información de perfil obtenida de Facebook (nombre, correo, foto, ID de Facebook).</Text></ListaItem>
              <ListaItem><Text>Vinculación entre tu cuenta de Facebook y tu cuenta en Kusina.</Text></ListaItem>
              <ListaItem><Text>Permisos de acceso otorgados a la aplicación Kusina en Facebook.</Text></ListaItem>
            </Lista>

            <AlertBox type="warning">
              <strong>Importante:</strong> La eliminación de datos de Facebook NO eliminará automáticamente
              tu cuenta completa de Kusina ni otros datos que hayas proporcionado directamente en nuestra
              plataforma (como direcciones de entrega, historial de pedidos, etc.). Si deseas eliminar
              completamente tu cuenta de Kusina, debes solicitarlo por separado contactando a
              soporte@kusina.site
            </AlertBox>

            <Subtitle>2.2. Plazo de Eliminación</Subtitle>
            <Text>
              Una vez recibida tu solicitud, procederemos a eliminar tus datos vinculados a Facebook dentro de un plazo de:
            </Text>
            <Lista>
              <ListaItem><Text><strong>Eliminación inmediata:</strong> Revocación de permisos y vinculación con Facebook (efectivo al momento de la solicitud).</Text></ListaItem>
              <ListaItem><Text><strong>Hasta 30 días:</strong> Eliminación completa de datos almacenados en nuestros sistemas.</Text></ListaItem>
              <ListaItem><Text><strong>Hasta 90 días:</strong> Eliminación de copias de respaldo y sistemas auxiliares.</Text></ListaItem>
            </Lista>
            <Text>
              Recibirás una confirmación por correo electrónico cuando el proceso de eliminación se haya completado.
            </Text>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>3. ¿Cómo Solicitar la Eliminación de Datos?</Heading>

            <Subtitle>Opción 1: Directamente desde tu Cuenta de Facebook</Subtitle>
            <Text>Puedes revocar el acceso de Kusina a tu cuenta de Facebook siguiendo estos pasos:</Text>
            <Lista>
              <ListaItem><Text>Inicia sesión en tu cuenta de Facebook.</Text></ListaItem>
              <ListaItem><Text>Ve a <strong>Configuración y Privacidad</strong> → <strong>Configuración</strong>.</Text></ListaItem>
              <ListaItem><Text>Selecciona <strong>Aplicaciones y sitios web</strong> en el menú de la izquierda.</Text></ListaItem>
              <ListaItem><Text>Busca "Kusina" o "Kusina App" en la lista de aplicaciones activas.</Text></ListaItem>
              <ListaItem><Text>Haz clic en <strong>Eliminar</strong> o <strong>Quitar</strong>.</Text></ListaItem>
              <ListaItem><Text>Confirma la acción para revocar todos los permisos.</Text></ListaItem>
            </Lista>
            <Text>
              Al eliminar la aplicación desde Facebook, se revocará el acceso, pero tus datos en nuestros
              servidores permanecerán hasta que solicites explícitamente su eliminación.
            </Text>

            <Subtitle>Opción 2: Formulario de Solicitud de Eliminación</Subtitle>
            <Text>
              Completa el siguiente formulario para solicitar formalmente la eliminación de tus datos
              vinculados a Facebook:
            </Text>

            {!submitted ? (
              <FormSection>
                <form onSubmit={handleSubmit}>
                  <FormLabel htmlFor="name">Nombre Completo *</FormLabel>
                  <FormInput
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Tu nombre completo"
                  />

                  <FormLabel htmlFor="email">Correo Electrónico *</FormLabel>
                  <FormInput
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="correo@ejemplo.com"
                  />

                  <FormLabel htmlFor="facebookId">ID de Usuario de Facebook (opcional)</FormLabel>
                  <FormInput
                    type="text"
                    id="facebookId"
                    name="facebookId"
                    value={formData.facebookId}
                    onChange={handleChange}
                    placeholder="Tu ID de Facebook si lo conoces"
                  />

                  <FormLabel htmlFor="reason">Motivo de la Solicitud *</FormLabel>
                  <FormTextarea
                    id="reason"
                    name="reason"
                    value={formData.reason}
                    onChange={handleChange}
                    required
                    placeholder="Por favor describe brevemente el motivo de tu solicitud..."
                  />

                  <FormLabel htmlFor="additionalInfo">Información Adicional (opcional)</FormLabel>
                  <FormTextarea
                    id="additionalInfo"
                    name="additionalInfo"
                    value={formData.additionalInfo}
                    onChange={handleChange}
                    placeholder="Cualquier información adicional que consideres relevante..."
                  />

                  <SubmitButton type="submit">
                    Enviar Solicitud de Eliminación
                  </SubmitButton>
                </form>
              </FormSection>
            ) : (
              <AlertBox type="success">
                <strong>¡Solicitud Recibida!</strong><br/>
                Hemos recibido tu solicitud de eliminación de datos. Recibirás un correo de confirmación
                en las próximas 24 horas con los detalles del proceso y un código de seguimiento.
                <br/><br/>
                <strong>Importante:</strong> Revisa tu bandeja de spam si no recibes el correo en las próximas horas.
              </AlertBox>
            )}

            <Subtitle>Opción 3: Contacto Directo por Correo Electrónico</Subtitle>
            <ContactBox>
              <Text>
                <strong>También puedes enviar tu solicitud por correo electrónico a:</strong>
              </Text>
              <Text>
                <EmailLink href="mailto:soporte@kusina.site?subject=Solicitud de Eliminación de Datos - Facebook Login">
                  soporte@kusina.site
                </EmailLink>
              </Text>
              <Text>
                <strong>Asunto del correo:</strong> "Solicitud de Eliminación de Datos - Facebook Login"
              </Text>
              <Text>
                <strong>Información a incluir:</strong>
              </Text>
              <Lista>
                <ListaItem><Text>Nombre completo</Text></ListaItem>
                <ListaItem><Text>Correo electrónico asociado a tu cuenta de Kusina</Text></ListaItem>
                <ListaItem><Text>ID de Facebook (si lo conoces)</Text></ListaItem>
                <ListaItem><Text>Motivo de tu solicitud</Text></ListaItem>
              </Lista>
            </ContactBox>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>4. Proceso de Eliminación</Heading>
            <Text>Una vez que recibamos tu solicitud, seguiremos el siguiente proceso:</Text>

            <Subtitleh3>Paso 1: Verificación de Identidad (1-2 días hábiles)</Subtitleh3>
            <Lista>
              <ListaItem><Text>Verificaremos tu identidad para asegurar que la solicitud proviene del titular legítimo de los datos.</Text></ListaItem>
              <ListaItem><Text>Podemos solicitar información adicional para confirmar tu identidad.</Text></ListaItem>
            </Lista>

            <Subtitleh3>Paso 2: Confirmación de Solicitud (1 día hábil)</Subtitleh3>
            <Lista>
              <ListaItem><Text>Te enviaremos un correo de confirmación con un código de seguimiento único.</Text></ListaItem>
              <ListaItem><Text>Explicaremos qué datos serán eliminados y cuáles se conservarán (si aplica).</Text></ListaItem>
            </Lista>

            <Subtitleh3>Paso 3: Eliminación de Datos (hasta 30 días)</Subtitleh3>
            <Lista>
              <ListaItem><Text>Procederemos a eliminar de forma segura e irreversible tus datos vinculados a Facebook de nuestros sistemas activos.</Text></ListaItem>
              <ListaItem><Text>Se revocará la vinculación entre tu cuenta de Facebook y Kusina.</Text></ListaItem>
              <ListaItem><Text>Se eliminarán los permisos de acceso otorgados a nuestra aplicación.</Text></ListaItem>
            </Lista>

            <Subtitleh3>Paso 4: Confirmación Final (1 día hábil después de completar)</Subtitleh3>
            <Lista>
              <ListaItem><Text>Te notificaremos por correo electrónico cuando el proceso se haya completado exitosamente.</Text></ListaItem>
              <ListaItem><Text>Recibirás un certificado de eliminación de datos (opcional, bajo solicitud).</Text></ListaItem>
            </Lista>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>5. Excepciones a la Eliminación</Heading>
            <Text>
              En algunos casos, podemos conservar cierta información incluso después de tu solicitud de eliminación:
            </Text>

            <Subtitle>5.1. Obligaciones Legales</Subtitle>
            <Lista>
              <ListaItem><Text>Datos requeridos por la legislación tributaria peruana (mínimo 5 años para comprobantes de pago).</Text></ListaItem>
              <ListaItem><Text>Información necesaria para cumplir con investigaciones legales, órdenes judiciales o requerimientos de autoridades.</Text></ListaItem>
              <ListaItem><Text>Datos relacionados con prevención de lavado de activos (hasta 10 años según normativa aplicable).</Text></ListaItem>
            </Lista>

            <Subtitle>5.2. Defensa de Derechos</Subtitle>
            <Lista>
              <ListaItem><Text>Información necesaria para la defensa de reclamos legales en curso o potenciales.</Text></ListaItem>
              <ListaItem><Text>Datos requeridos para resolver disputas, fraudes o incidentes de seguridad.</Text></ListaItem>
            </Lista>

            <Subtitle>5.3. Datos Anonimizados</Subtitle>
            <Lista>
              <ListaItem><Text>Datos completamente anonimizados y agregados que no permiten tu identificación personal pueden conservarse para análisis estadísticos.</Text></ListaItem>
            </Lista>

            <AlertBox type="info">
              <strong>Nota:</strong> Si conservamos algún dato bajo estas excepciones, te informaremos
              específicamente qué información se retiene y por qué motivo legal.
            </AlertBox>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>6. Consecuencias de la Eliminación</Heading>
            <Text>Al eliminar tus datos vinculados a Facebook, debes tener en cuenta lo siguiente:</Text>

            <Lista>
              <ListaItem>
                <Text><strong>No podrás iniciar sesión con Facebook:</strong> Deberás utilizar otros métodos de inicio de sesión (correo/contraseña, Google, etc.) o crear una nueva cuenta.</Text>
              </ListaItem>
              <ListaItem>
                <Text><strong>Pérdida de vinculación:</strong> Se perderá la conexión entre tu cuenta de Kusina y Facebook.</Text>
              </ListaItem>
              <ListaItem>
                <Text><strong>Configuraciones personalizadas:</strong> Cualquier configuración o preferencia basada en tu perfil de Facebook se restablecerá a valores predeterminados.</Text>
              </ListaItem>
              <ListaItem>
                <Text><strong>Proceso irreversible:</strong> Una vez completada la eliminación, no podremos recuperar tus datos. Deberás proporcionar nuevamente tu información si deseas usar Facebook Login en el futuro.</Text>
              </ListaItem>
            </Lista>

            <AlertBox type="warning">
              <strong>Atención:</strong> Si deseas continuar usando Kusina después de eliminar tus datos de Facebook,
              asegúrate de tener configurado otro método de inicio de sesión (correo/contraseña) antes de proceder
              con la eliminación.
            </AlertBox>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>7. Preguntas Frecuentes (FAQ)</Heading>

            <Subtitleh3>¿Cuánto tiempo tarda el proceso de eliminación?</Subtitleh3>
            <Text>
              El proceso completo puede tardar hasta 30 días desde que verificamos tu identidad.
              La revocación de permisos de Facebook es inmediata, pero la eliminación total de
              nuestros sistemas puede tomar varias semanas.
            </Text>

            <Subtitleh3>¿Puedo cancelar mi solicitud de eliminación?</Subtitleh3>
            <Text>
              Sí, puedes cancelar tu solicitud dentro de los primeros 7 días desde que la enviaste.
              Después de ese período, el proceso de eliminación será irreversible.
            </Text>

            <Subtitleh3>¿Se eliminará mi cuenta completa de Kusina?</Subtitleh3>
            <Text>
              No, esta solicitud solo elimina los datos vinculados a Facebook Login. Tu cuenta de
              Kusina permanecerá activa con los datos que hayas proporcionado directamente.
              Para eliminar tu cuenta completa, debes hacer una solicitud separada.
            </Text>

            <Subtitleh3>¿Qué pasa con mi historial de pedidos?</Subtitleh3>
            <Text>
              Tu historial de pedidos, transacciones y comprobantes de pago se conservarán según
              las obligaciones legales tributarias de Perú (mínimo 5 años), aunque tu vinculación
              con Facebook sea eliminada.
            </Text>

            <Subtitleh3>¿Puedo volver a usar Facebook Login después de eliminar mis datos?</Subtitleh3>
            <Text>
              Sí, puedes volver a vincular tu cuenta de Facebook en cualquier momento. Sin embargo,
              será tratado como un nuevo registro y deberás otorgar nuevamente los permisos necesarios.
            </Text>

            <Subtitleh3>¿Cómo puedo verificar que mis datos fueron eliminados?</Subtitleh3>
            <Text>
              Te enviaremos una confirmación por correo electrónico cuando el proceso se complete.
              Además, puedes solicitar un certificado de eliminación de datos contactando a
              soporte@kusina.site
            </Text>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>8. Información de Contacto</Heading>

            <Text>Si tienes preguntas, inquietudes o necesitas asistencia con tu solicitud de eliminación de datos:</Text>

            <ContactBox>
              <Lista>
                <ListaItem><Text><strong>Razón Social:</strong> KUSINA APP E.I.R.L.</Text></ListaItem>
                <ListaItem><Text><strong>RUC:</strong> 20613753983</Text></ListaItem>
                <ListaItem><Text><strong>Correo de Soporte:</strong> <EmailLink href="mailto:soporte@kusina.site">soporte@kusina.site</EmailLink></Text></ListaItem>
                <ListaItem><Text><strong>Teléfono:</strong> +51 973 834 813</Text></ListaItem>
                <ListaItem><Text><strong>Domicilio:</strong> Av. Javier Padro Este Nro. 560 Int. 1302, Lima, Lima, San Isidro</Text></ListaItem>
                <ListaItem><Text><strong>Horario de Atención:</strong> Lunes a Viernes de 9:00 AM a 6:00 PM (hora de Perú)</Text></ListaItem>
              </Lista>
            </ContactBox>

            <Subtitle>Autoridad de Protección de Datos</Subtitle>
            <Text>
              Si consideras que tus derechos de protección de datos no han sido respetados, puedes
              presentar una queja ante:
            </Text>
            <Lista>
              <ListaItem><Text><strong>Autoridad Nacional de Protección de Datos Personales</strong></Text></ListaItem>
              <ListaItem><Text>Dirección General de Transparencia, Acceso a la Información Pública y Protección de Datos Personales</Text></ListaItem>
              <ListaItem><Text>Ministerio de Justicia y Derechos Humanos</Text></ListaItem>
              <ListaItem><Text>Calle Scipión Llona 350, Miraflores, Lima, Perú</Text></ListaItem>
              <ListaItem><Text>Teléfono: (01) 204-8020</Text></ListaItem>
              <ListaItem><Text>Correo: protecciondedatospersonales@minjus.gob.pe</Text></ListaItem>
            </Lista>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>9. Información Técnica para Desarrolladores</Heading>

            <Text>
              Esta página cumple con los requisitos de <strong>Data Deletion Callback</strong> de Facebook
              para aplicaciones que utilizan Facebook Login, según la documentación oficial:
            </Text>

            <AlertBox type="info">
              <strong>Referencia:</strong> Facebook Developers - Data Deletion Request Callback
              <br/>
              <EmailLink
                href="https://developers.facebook.com/docs/development/create-an-app/app-dashboard/data-deletion-callback"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://developers.facebook.com/docs/development/create-an-app/app-dashboard/data-deletion-callback
              </EmailLink>
            </AlertBox>

            <Subtitle>Endpoint de Callback (Para Facebook App Dashboard)</Subtitle>
            <Text>
              <strong>URL de Callback:</strong> https://landing-kusina-site-d65119620fdc.herokuapp.com/data-deletion-request
            </Text>
            <Text>
              Esta URL debe ser configurada en el <strong>Facebook App Dashboard</strong> en la sección
              "Configuración de la Aplicación" → "Configuración Básica" → "URL de Eliminación de Datos del Usuario".
            </Text>

            <Subtitle>Método de Implementación</Subtitle>
            <Text>
              Kusina procesa las solicitudes de eliminación de datos de las siguientes maneras:
            </Text>
            <Lista>
              <ListaItem><Text><strong>Interfaz web (esta página):</strong> Los usuarios pueden solicitar la eliminación manualmente.</Text></ListaItem>
              <ListaItem><Text><strong>Callback automático de Facebook:</strong> Cuando un usuario elimina la aplicación desde su configuración de Facebook, se envía una notificación automática a nuestro endpoint.</Text></ListaItem>
              <ListaItem><Text><strong>Correo electrónico:</strong> Los usuarios pueden enviar solicitudes por correo.</Text></ListaItem>
            </Lista>
          </DataDeletionSection>

          <DataDeletionSection>
            <Heading>Compromiso de Kusina con tu Privacidad</Heading>
            <Text>
              En Kusina respetamos tu derecho a la privacidad y al control de tus datos personales.
              Procesamos todas las solicitudes de eliminación de datos de manera seria, transparente
              y conforme a la legislación peruana de protección de datos.
            </Text>
            <Text>
              Si tienes alguna pregunta o inquietud sobre cómo manejamos tus datos, no dudes en
              contactarnos. Estamos aquí para ayudarte.
            </Text>

            <Subtitle style={{marginTop: '30px'}}><strong>KUSINA APP E.I.R.L.</strong></Subtitle>
            <Text><strong>RUC:</strong> 20613753983</Text>
            <Text><strong>Email:</strong> soporte@kusina.site</Text>
            <Text><strong>Teléfono:</strong> +51 973 834 813</Text>
            <Text><strong>Última actualización:</strong> 16 de diciembre de 2025</Text>
          </DataDeletionSection>

        </Container>
      </DataDeletionSec>
    </>
  )
}

export default DataDeletionRequest
